<template>
    <div class="user-panel-wrapper">
        <user-panel-header class="border-bottom"></user-panel-header>
        <breadcrumbs :hide-level="1" />
        <b-container fluid class="user-panel-main">
            <router-view></router-view>
        </b-container>
        <user-panel-footer />
    </div>
</template>

<script>
    import UserPanelHeader from '~cp/UserPanel/Elements/UserPanelHeader'
    import UserPanelFooter from '~cp/UserPanel/Elements/UserPanelFooter'
    import Breadcrumbs from '~cp/UserPanel/Elements/Breadcrumbs/Breadcrumbs.vue'

    export default {
        name: 'UserPanel',
        components: {
            UserPanelHeader,
            UserPanelFooter,
            Breadcrumbs
        },
        data() {
            return {
            }
        },
        created() {
            this.getDataFromLocalStorage()
            this.checkUserAddress()
        },
        methods: {
            getDataFromLocalStorage() {
                if (localStorage.getItem('inventoryManagementColumns')) {
                    this.$store.commit('UPDATE_INVENTORY_COLUMNS', JSON.parse(localStorage.getItem('inventoryManagementColumns')))
                }
                if (localStorage.getItem('suspendedProductColumns')) {
                    this.$store.commit('UPDATE_SUSPENDED_COLUMNS', JSON.parse(localStorage.getItem('suspendedProductColumns')))
                }
            },
            checkUserAddress() {
                if (localStorage.getItem('hasDefaultAddress')) {
                    this.$store.commit('EXIST_DEFAULT_ADDRESS', true)
                } else {
                    this.$store.dispatch('getUserAddresses').then(response => {
                        let hasDefaultAddress = response.findIndex(item => item.default) !== -1
                        if (hasDefaultAddress) {
                            localStorage.setItem('hasDefaultAddress', 'true')
                            this.checkUserAddress()
                        } else {
                            this.$router.push({name: 'ShippingSettings'})
                        }
                    })
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/UserPanel/UserPanel.vue